<ion-content *mobxAutorun>
  <ion-card class="ion-no-margin ion-justify-content-between ly-col flex md-border">
    <ion-row class="ion-margin-horizontal ion-margin-top" *ngIf="!fullView">
      <ion-text color="medium">
        <b>{{ 'components.leaderboardList.title' | translate }}</b>
      </ion-text>
    </ion-row>
    <ion-list class="flex">
      <leaderboard-card
        *ngFor="
          let leaderboardItem of $any(
            paginatedLeaderboard ? paginatedLeaderboard.items : ['', '', '']
          );
          let i = index
        "
        [leaderboard]="leaderboardItem"
        [loading]="loading"
        [index]="i"
      >
      </leaderboard-card>
      <empty-state
        *ngIf="!loading && !paginatedLeaderboard?.items?.length"
        title="components.leaderboardList.messages.emptyTitle"
        description=""
        [showAction]="false"
      >
      </empty-state>
    </ion-list>
    <ion-row class="stretch-x" *ngIf="showFullButton">
      <ion-button
        class="ion-no-margin stretch-x"
        expand="full"
        [routerLink]="['/workspace/leaderboard']"
      >
        <ion-icon name="list" slot="start"> </ion-icon>
        {{ 'components.leaderboardList.buttons.viewFullLeaderboard' | translate }}
      </ion-button>
    </ion-row>
  </ion-card>

  <ion-infinite-scroll
    *ngIf="paginatedLeaderboard?.items?.length && paginatedLeaderboard?.canLoadMore"
    threshold="800px"
    (ionInfinite)="reachedInfinity($any($event))"
    class="ion-margin-top"
  >
    <ion-infinite-scroll-content
      loadingSpinner="dots"
      [loadingText]="'components.leaderboardList.messages.loadingMore' | translate"
    >
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
